import { render, staticRenderFns } from "./StepBrindes.vue?vue&type=template&id=d05dc770"
import script from "./StepBrindes.vue?vue&type=script&lang=js"
export * from "./StepBrindes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports